import { render, staticRenderFns } from "./advert.vue?vue&type=template&id=b5b4bd48&scoped=true&"
import script from "./advert.vue?vue&type=script&lang=js&"
export * from "./advert.vue?vue&type=script&lang=js&"
import style0 from "./advert.vue?vue&type=style&index=0&id=b5b4bd48&lang=scss&scoped=true&"
import style1 from "./advert.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./advert.vue?vue&type=style&index=2&id=b5b4bd48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b4bd48",
  null
  
)

export default component.exports